/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// Custom Components
import MDBox from "components/MDBox";
import Status from "components/Table/Status";
import Author from "components/Table/Author";
import RiskFactor from "components/Table/RiskFactor";
import By from "components/Table/By";

// 3rd party library
import moment from "moment";

// MUI Components
import { IconButton } from "@mui/material";

// Constants and Utils
import Constants, { Icons, defaultData } from "utils/Constants";
import { getFormattedProjectName } from "utils/methods/methods";

export default function QHSEData({ viewQHSEDetails }) {
  const [qhseRows, setRows] = useState([]);
  const safetyCards = useSelector((state) => state.projectMap.qhseList);
  const ConfigData = useSelector((state) => state.config);

  const screens = ConfigData?.screens;
  useEffect(() => {
    if (Array.isArray(safetyCards) && safetyCards.length > 0) {
      const list = [];
      safetyCards.forEach((item, index) => {
        const temp = {
          srNo: <Author name={index + 1} />,
          title: <Author name={item.title ? item.title : ""} maxContent={20} />,
          project: (
            <Author
              name={getFormattedProjectName(item.project)}
              nickName={item.defaultProject?.title ?? ""}
              maxContent={defaultData.MEDIUM_CONTENT_LENGTH}
            />
          ),
          type: (
            <Author
              icon={item?.images && item.images.length > 0 ? Icons.ATTACHMENT : null}
              name={item?.cardType === Constants.NCR_VALUE ? "NCR" : item?.cardType}
            />
          ),
          location: (
            <Author name={item?.location?.title} maxContent={defaultData.MEDIUM_CONTENT_LENGTH} />
          ),
          category: (
            <Author
              name={item?.category?.categoryName}
              maxContent={defaultData.MEDIUM_CONTENT_LENGTH}
            />
          ),
          riskFactor: item?.riskFactor && <RiskFactor risk={parseInt(item?.riskFactor, 10)} />,
          status: (
            <Status
              title={`${
                item?.status === "submitted(client)"
                  ? "submitted to client"
                  : item?.status.replace("_", " ")
              }`}
            />
          ),
          createdBy: (
            <By
              name={`${
                item.createdBy?.callingName
                  ? item.createdBy?.callingName
                  : item.createdBy?.firstName
              } ${item.createdBy?.lastName}`}
              isSuperAdmin={item.createdBy?.role?.title === defaultData.SUPER_ADMIN_ROLE}
              when={moment(item?.createdAt).format(defaultData.WEB_DATE_FORMAT)}
            />
          ),
          lastChangedBy: (
            <By
              name={
                item.updatedBy
                  ? `${
                      item.updatedBy?.callingName
                        ? item.updatedBy?.callingName
                        : item.updatedBy?.firstName
                    } ${item.updatedBy?.lastName} `
                  : ""
              }
              isSuperAdmin={item.updatedBy?.role?.title === defaultData.SUPER_ADMIN_ROLE}
              when={moment(item?.updatedAt).format(defaultData.WEB_DATE_FORMAT)}
            />
          ),
          action: (
            <MDBox>
              <IconButton
                aria-label="fingerprint"
                color="info"
                onClick={() => viewQHSEDetails(item?.[Constants.MONGOOSE_ID])}
              >
                {Icons.VIEW}
              </IconButton>
            </MDBox>
          ),
        };
        list.push(temp);
      });
      setRows(list);
    } else {
      setRows([]);
    }
  }, [safetyCards, screens, viewQHSEDetails]);

  return {
    qhseColumns: [
      { Header: "No.", accessor: "srNo", width: "3%" },
      { Header: "Type", accessor: "type", align: "left", width: "5%" },
      { Header: "Title", accessor: "title", align: "left", width: "30%" },
      { Header: "Location", accessor: "location", align: "left", width: "10%" },
      { Header: "Category", accessor: "category", align: "left", width: "8%" },
      { Header: "Risk Factor", accessor: "riskFactor", width: "5%", align: "left" },
      { Header: "Status", accessor: "status", align: "left", width: "5%" },
      { Header: "Action", accessor: "action", align: "center", width: "5%" },
    ],
    qhseRows,
  };
}
